export default __webpack_public_path__ + "static/media/template_pro__0004_23---DanSmith.46471026.png";